import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../../assets/images/closeIconModal.svg";
import User from "../../../../assets/images/userIcon.png";

const DisputeModal = ({
  show,
  onCloseClick,
  onConfirm,
  selectedItem,
}: {
  show: boolean;
  selectedItem: any;
  onConfirm: (reason: string) => void;
  onCloseClick: () => void;
}) => {
  const [reason, setReason] = useState<string>("");

  useEffect(() => {
    console.log(selectedItem, "item");
    if (show) {
      setReason("");
    }
  }, [show]);

  const handleSubmit = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleReason = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
  };

  useEffect(() => {
    console.log(selectedItem, "item");
  }, []);

  return (
    <Modal isOpen={show} centered={true} className="reasonModl">
      <ModalBody className="modal_Body">
        <img
          data-testing-id="closeIcon"
          onClick={onCloseClick}
          className="closeIconModal"
          src={CLoseImg}
          alt=""
        />
        <div className="Replay">
          <h3>Submit a Dispute</h3>
          <h3>
            {" "}
            <img src={User} alt="" />{" "}
            <span>{selectedItem.userName || "-"}</span>
          </h3>
        </div>
        <div className="refund">
          <textarea
            data-testing-id="diputeReply_disputeModal"
            placeholder="Write Reply"
            value={reason}
            onChange={handleReason}
          ></textarea>
        </div>
        <div className="suBit">
          <button onClick={handleSubmit} data-testing-id="submit_Disputemodal">
            Submit
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

DisputeModal.propTypes = {
  onCloseClick: PropTypes.func,
  onConfirm: PropTypes.func,
  show: PropTypes.bool,
  selectedItem: PropTypes.any,
};

export default DisputeModal;
